import { render, staticRenderFns } from "./SystemCorporateContact.vue?vue&type=template&id=5c5a7654&"
import script from "./SystemCorporateContact.vue?vue&type=script&lang=js&"
export * from "./SystemCorporateContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c5a7654')) {
      api.createRecord('5c5a7654', component.options)
    } else {
      api.reload('5c5a7654', component.options)
    }
    module.hot.accept("./SystemCorporateContact.vue?vue&type=template&id=5c5a7654&", function () {
      api.rerender('5c5a7654', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/SystemCorporateContact.vue"
export default component.exports